/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CommentType {
  FOOTER = "FOOTER",
  INLINE = "INLINE",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}

export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ActiveCommentsQuery
// ====================================================

export interface ActiveCommentsQuery_comments_nodes_author_Anonymous_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_author_Anonymous {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_author_Anonymous_profilePicture | null;
  permissionType: SitePermissionType | null;
}

export interface ActiveCommentsQuery_comments_nodes_author_KnownUser_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_author_KnownUser {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_author_KnownUser_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_author_User_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_author_User {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_author_User_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type ActiveCommentsQuery_comments_nodes_author = ActiveCommentsQuery_comments_nodes_author_Anonymous | ActiveCommentsQuery_comments_nodes_author_KnownUser | ActiveCommentsQuery_comments_nodes_author_User;

export interface ActiveCommentsQuery_comments_nodes_body {
  value: string;
}

export interface ActiveCommentsQuery_comments_nodes_createdAt {
  value: string;
}

export interface ActiveCommentsQuery_comments_nodes_links {
  webui: string | null;
  editui: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_location_InlineComment_inlineResolveProperties {
  isDangling: boolean;
  resolvedTime: any | null;
  resolvedFriendlyDate: string | null;
  resolvedUser: string | null;
  resolved: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineText: string | null;
  inlineResolveProperties: ActiveCommentsQuery_comments_nodes_location_InlineComment_inlineResolveProperties | null;
}

export interface ActiveCommentsQuery_comments_nodes_location_FooterComment_commentResolveProperties {
  resolved: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_location_FooterComment {
  type: string;
  commentResolveProperties: ActiveCommentsQuery_comments_nodes_location_FooterComment_commentResolveProperties | null;
}

export type ActiveCommentsQuery_comments_nodes_location = ActiveCommentsQuery_comments_nodes_location_InlineComment | ActiveCommentsQuery_comments_nodes_location_FooterComment;

export interface ActiveCommentsQuery_comments_nodes_permissions {
  isEditable: boolean;
  isRemovable: boolean;
  isResolvable: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_version_by {
  displayName: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_version {
  by: ActiveCommentsQuery_comments_nodes_version_by | null;
  when: string | null;
  number: number | null;
}

export interface ActiveCommentsQuery_comments_nodes_reactionsSummary_reactionsSummaryForEmoji {
  id: string;
  emojiId: string;
  count: number;
  reacted: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_reactionsSummary {
  ari: string;
  containerAri: string;
  reactionsCount: number;
  reactionsSummaryForEmoji: (ActiveCommentsQuery_comments_nodes_reactionsSummary_reactionsSummaryForEmoji | null)[];
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_Anonymous_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_Anonymous {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_replies_author_Anonymous_profilePicture | null;
  permissionType: SitePermissionType | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_KnownUser_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_KnownUser {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_replies_author_KnownUser_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_User_profilePicture {
  path: string;
}

export interface ActiveCommentsQuery_comments_nodes_replies_author_User {
  displayName: string | null;
  profilePicture: ActiveCommentsQuery_comments_nodes_replies_author_User_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type ActiveCommentsQuery_comments_nodes_replies_author = ActiveCommentsQuery_comments_nodes_replies_author_Anonymous | ActiveCommentsQuery_comments_nodes_replies_author_KnownUser | ActiveCommentsQuery_comments_nodes_replies_author_User;

export interface ActiveCommentsQuery_comments_nodes_replies_body {
  value: string;
}

export interface ActiveCommentsQuery_comments_nodes_replies_createdAt {
  value: string;
}

export interface ActiveCommentsQuery_comments_nodes_replies_links {
  webui: string | null;
  editui: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_location_InlineComment_inlineResolveProperties {
  isDangling: boolean;
  resolvedTime: any | null;
  resolvedFriendlyDate: string | null;
  resolvedUser: string | null;
  resolved: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_replies_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineText: string | null;
  inlineResolveProperties: ActiveCommentsQuery_comments_nodes_replies_location_InlineComment_inlineResolveProperties | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_location_FooterComment_commentResolveProperties {
  resolved: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_location_FooterComment {
  type: string;
  commentResolveProperties: ActiveCommentsQuery_comments_nodes_replies_location_FooterComment_commentResolveProperties | null;
}

export type ActiveCommentsQuery_comments_nodes_replies_location = ActiveCommentsQuery_comments_nodes_replies_location_InlineComment | ActiveCommentsQuery_comments_nodes_replies_location_FooterComment;

export interface ActiveCommentsQuery_comments_nodes_replies_permissions {
  isEditable: boolean;
  isRemovable: boolean;
  isResolvable: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_replies_version_by {
  displayName: string | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_version {
  by: ActiveCommentsQuery_comments_nodes_replies_version_by | null;
  when: string | null;
  number: number | null;
}

export interface ActiveCommentsQuery_comments_nodes_replies_reactionsSummary_reactionsSummaryForEmoji {
  id: string;
  emojiId: string;
  count: number;
  reacted: boolean;
}

export interface ActiveCommentsQuery_comments_nodes_replies_reactionsSummary {
  ari: string;
  containerAri: string;
  reactionsCount: number;
  reactionsSummaryForEmoji: (ActiveCommentsQuery_comments_nodes_replies_reactionsSummary_reactionsSummaryForEmoji | null)[];
}

export interface ActiveCommentsQuery_comments_nodes_replies {
  id: string;
  author: ActiveCommentsQuery_comments_nodes_replies_author;
  body: ActiveCommentsQuery_comments_nodes_replies_body;
  contentStatus: string;
  createdAt: ActiveCommentsQuery_comments_nodes_replies_createdAt;
  createdAtNonLocalized: string;
  links: ActiveCommentsQuery_comments_nodes_replies_links;
  location: ActiveCommentsQuery_comments_nodes_replies_location;
  parentId: string | null;
  permissions: ActiveCommentsQuery_comments_nodes_replies_permissions;
  version: ActiveCommentsQuery_comments_nodes_replies_version;
  reactionsSummary: ActiveCommentsQuery_comments_nodes_replies_reactionsSummary | null;
}

export interface ActiveCommentsQuery_comments_nodes {
  id: string;
  author: ActiveCommentsQuery_comments_nodes_author;
  body: ActiveCommentsQuery_comments_nodes_body;
  contentStatus: string;
  createdAt: ActiveCommentsQuery_comments_nodes_createdAt;
  createdAtNonLocalized: string;
  links: ActiveCommentsQuery_comments_nodes_links;
  location: ActiveCommentsQuery_comments_nodes_location;
  parentId: string | null;
  permissions: ActiveCommentsQuery_comments_nodes_permissions;
  version: ActiveCommentsQuery_comments_nodes_version;
  reactionsSummary: ActiveCommentsQuery_comments_nodes_reactionsSummary | null;
  replies: (ActiveCommentsQuery_comments_nodes_replies | null)[];
}

export interface ActiveCommentsQuery_comments {
  nodes: (ActiveCommentsQuery_comments_nodes | null)[] | null;
  totalCount: number | null;
}

export interface ActiveCommentsQuery {
  comments: ActiveCommentsQuery_comments | null;
}

export interface ActiveCommentsQueryVariables {
  pageId: string;
  contentStatus?: (GraphQLContentStatus | null)[] | null;
  type?: (CommentType | null)[] | null;
}
